import React from "react";
import Projects from "../Projects/Projects";
import { projectsData } from "./../../assets/Data/data";
import "./Skills.css";

const Skills = () => {
  return (
    <div className="skills section">
      <h2 className="section_title text-center text-2xl font-bold text-white mb-8">
        My Projects
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {projectsData.map((project) => (
          <Projects project={project} key={project.id} />
        ))}
      </div>
    </div>
  );
};

export default Skills;
